const CAP15 = {
  "id": 41,
  "title": "Qué es una dirección Bitcoin",
  "subtitle": "Curso Bitcoin 101",
  "sections": [
    {
      "heading": "Introducción: ¿Qué es una dirección Bitcoin?",
      "text": [
        "Una dirección, en el mundo de las criptomonedas, es el lugar al que se asocia una determinada cantidad de monedas virtuales. Toda persona o usuario que quiera enviar o recibir criptomonedas necesitará siempre una dirección.",
        "La dirección funciona al igual que el número de cuenta de un banco tradicional para recibir o enviar transferencias de dinero. Pero a diferencia de las cuentas bancarias, en Bitcoin y el resto de criptomonedas ese número se le conoce como dirección o wallet address en inglés. El objetivo de las direcciones es permitirnos recibir y enviar criptomonedas."
      ]
    },
    {
      "heading": "Ejemplo de dirección Bitcoin (Legacy o estándar)",
      "text": [
        "En Bitcoin, las direcciones se identifican de acuerdo a las primeras letras de la misma. Si la dirección comienza con el número 1, se trata de una dirección Legacy o estándar, normalmente con esta apariencia:",
        "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa"
      ]
    },
    {
      "heading": "¿Cómo lucen estas direcciones?",
      "text": [
        "A simple vista, la dirección es bastante críptica, pudiendo apreciar enormes diferencias con los acostumbrados números de cuenta bancarios, que son fáciles de leer y memorizar porque utilizan solo números.",
        "Pero las direcciones de criptomonedas aplican una combinación de números y letras, entre minúsculas y mayúsculas. Por lo que podemos decir entonces que son direcciones alfanuméricas, y esto tiene un claro objetivo: proveer direcciones con alta seguridad y sin límites de creación."
      ]
    },
    {
      "heading": "Longitud y prefijos",
      "text": [
        "Las direcciones de criptomonedas tienen una mayor longitud. La longitud varía entre los 26 y 62 caracteres.",
        "En Bitcoin, estas empiezan por:"
      ],
      "list": [
        "• Número 1 → Direcciones estándar (P2PKH)",
        "• Número 3 → Direcciones multifirma (P2SH)",
        "• bc1q → Direcciones SegWit (bech32)",
        "• bc1p → Direcciones Taproot"
      ]
    },
    {
      "heading": "Direcciones como código QR",
      "text": [
        "Otra forma común de representar las direcciones Bitcoin es por medio de un código QR.",
        "Los códigos QR son una representación gráfica creada por un algoritmo hash gráfico. Es decir, que siempre se generará el mismo gráfico si introducimos la misma información.",
        "De esta forma puede compartirse la dirección más cómodamente, especialmente en sitios públicos, ya que el código puede ser escaneado mediante la cámara de un smartphone."
      ]
    },
    {
      "heading": "Características de una dirección Bitcoin",
      "list": [
        "Sin límites: una persona puede crear tantas direcciones como quiera, sin límites.",
        "Son libres: no necesitas pedir permiso a nadie para crear direcciones.",
        "Son completamente gratuitas: no generan ningún coste, ni requieren pagos.",
        "Privacidad: tus datos personales nunca se asocian directamente a una dirección.",
        "Transparencia: si publicas tu dirección, todos podrán ver tus saldos y operaciones.",
        "Seguridad: compartir tu dirección no supone riesgo de robo, solo permite recibir fondos.",
        "Proceso sencillo: crear direcciones es muy fácil, basta con descargar un monedero.",
        "Pueden crearse sin conexión (offline), sin necesidad de tener acceso a Internet.",
        "Case-sensitive: las direcciones antiguas distinguen entre mayúsculas y minúsculas, pero el nuevo formato bech32 elimina esta limitación."
      ]
    },
    {
      "heading": "Tipos de direcciones en Bitcoin",
      "text": [
        "Las direcciones Legacy eran el único tipo al inicio, pero con el avance de Bitcoin surgieron formatos más eficientes y seguros.",
        "Los principales tipos son:"
      ],
      "subsections": [
        {
          "subheading": "Direcciones multifirma (P2SH)",
          "text": [
            "Permiten la creación de wallets que requieren múltiples firmas privadas para acceder a los fondos.",
            "Utilizan un script con condiciones específicas de gasto, y comienzan con el prefijo '3'.",
            "Son útiles en empresas, organizaciones o cuentas compartidas.",
            "Enviarle BTC a una P2SH es aproximadamente un 26% más barato que a una dirección Legacy."
          ]
        },
        {
          "subheading": "Direcciones SegWit (P2WPKH)",
          "text": [
            "También conocidas como 'bech32', comienzan con 'bc1q'.",
            "Optimiza el tamaño de las transacciones y reduce hasta un 16% más de coste que las P2SH y 38% menos que las Legacy.",
            "Son el formato más eficiente, aunque no todos los exchanges y wallets las soportan aún."
          ]
        },
        {
          "subheading": "Direcciones Taproot (P2TR)",
          "text": [
            "Comienzan con 'bc1p' y pueden llegar hasta 62 caracteres.",
            "Introducen nuevas capacidades de contratos inteligentes, optimización de privacidad y ahorro de espacio.",
            "Permiten transacciones más privadas, más compactas y eficientes, especialmente para multifirmas."
          ]
        },
        {
          "subheading": "Direcciones Testnet",
          "text": [
            "Se usan exclusivamente para pruebas y simulaciones dentro de la red.",
            "Comienzan con los prefijos 'm' o '2'.",
            "Funcionan igual que las direcciones reales, pero no tienen valor económico."
          ]
        }
      ]
    }
  ]
}


export default CAP15;
